import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import {
  INoteRequest,
  INoteResponse,
  INoteDocsRequest,
  INoteDocsResponse,
  IAddNoteRequest,
  IAddNoteResponse,
  IDownloadNoteDocumentRequest,
  IEditNoteRequest,
  IEditNoteResponse
} from '../models/note.model';

// Notes
export const loadNoteRequest = createAction('[Note] Load Note Request', props<{ request: string }>());

export const loadNoteSuccess = createAction('[Note] Load Note Success', props<{ response: INoteResponse[] }>());

export const loadNoteFailure = createAction('[Note] Load Note Failure', props<{ error: Error | any }>());

// Note Documents
export const loadNoteDocsRequest = createAction('[NoteDocs] Load Note Docs Request', props<{ request: INoteDocsRequest }>());

export const loadNoteDocsSuccess = createAction('[NoteDocs] Load Note Docs Success', props<{ response: INoteDocsResponse[] }>());

export const loadNoteDocsFailure = createAction('[NoteDocs] Load Note Docs Failure', props<{ error: Error | any }>());

// Add Note
export const addNoteRequest = createAction('[AddNote] Add Note Request', props<{ request: IAddNoteRequest }>());

export const addNoteSuccess = createAction('[AddNote] Add Note Success', props<{ response: IAddNoteResponse[] }>());

export const addNoteFailure = createAction('[AddNote] Add Note Failure', props<{ error: Error | any }>());

// Open Note Document
export const loadDownloadNoteDocuments = createAction(
  '[DownloadNoteDocument] Load Download Note Documents',
  props<{ request: IDownloadNoteDocumentRequest }>()
);

export const loadDownloadNoteDocumentsSuccess = createAction(
  '[DownloadNoteDocument] Load Download Note Documents Success',
  props<{ response: string }>()
);

export const loadDownloadNoteDocumentsFailure = createAction(
  '[DownloadNoteDocument] Load Download Note Documents Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

// Edit Note
export const editNoteRequest = createAction('[EditNote] Edit Note Request', props<{ request: IEditNoteRequest }>());

export const editNoteSuccess = createAction('[EditNote] Edit Note Success', props<{ response: IEditNoteResponse[] }>());

export const editNoteFailure = createAction('[EditNote] Edit Note Failure', props<{ error: Error | any }>());

// Delete Note Document (uploaded file)
export const deleteNoteDocumentRequest = createAction(
  '[NoteDocs] Delete Note Document Request',
  props<{ customerId: string; customerAdminNotesId: string; uploadedFileId: string }>()
);

export const deleteNoteDocumentSuccess = createAction('[NoteDocs] Delete Note Document Success');

export const deleteNoteDocumentFailure = createAction(
  '[NoteDocs] Delete Note Document Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
